module.exports = __webpack_public_path__ + "40fb0b025049f63daccb27946c449308.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/Goldencity-voll.jpg
// module id = 508
// module chunks = 0